import Select from 'react-select';
import styled from 'styled-components';

const LawmakerContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  ${(props) =>
    props.$isActive
      ? 'padding-bottom: 1rem; border-bottom: 1px solid #cccccc;'
      : ''}

  @media (max-width: 768px) {
    display: ${(props) => (props.$isMobile ? 'flex' : 'none')};
  }
`;

const LawmakerWrapper = styled.div`
  width: 100%;
`;

const LawmakerLabel = styled.label`
  display: ${(props) => (props.$isActive ? 'block' : 'none')};
  font-size: 0.75rem;
  font-weight: 600;
  color: #666666;
  text-transform: uppercase;
  margin-bottom: 0.25rem;
`;

export const ArchiveLawmakerSelector = ({
  legislators,
  setSelectedLegislators,
  selectedLegislators,
  isMobile = false,
  isActive = false,
}) => {
  const selectStyles = {
    control: (base) => ({
      ...base,
      border: '1px solid #cccccc',
      borderRadius: '0.25rem',
      boxShadow: 'none',
      minHeight: '2rem',
      fontSize: '0.875rem',
      '&:hover': {
        border: '1px solid #cccccc',
      },
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    placeholder: (base) => ({
      ...base,
      color: '#212121',
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: '#212121',
      padding: '0 0.5rem 0 0',
      '&:hover': {
        color: '#000000',
      },
    }),
    input: (base) => ({
      ...base,
      margin: 0,
      padding: 0,
    }),
  };

    const handleSelect = (option) => {
    if (!option) {
      setSelectedLegislators([]);
      return;
    }
    if (!selectedLegislators.includes(option.value)) {
      setSelectedLegislators([...selectedLegislators, option.value]);
    }
  };

  return (
    <LawmakerContainer $isMobile={isMobile} $isActive={isActive}>
      <LawmakerLabel $isActive={isActive} htmlFor="archive-lawmaker-select">
        Legislators
      </LawmakerLabel>
      <LawmakerWrapper $isMobile={isMobile}>
        <Select
          options={legislators}
          placeholder="Legislators"
          onChange={handleSelect}
          value={null}
          isClearable={true}
          styles={selectStyles}
        />
      </LawmakerWrapper>
    </LawmakerContainer>
  );
};
